<circle-progress
  [radius]="radius"
  [percent]="data"
  [outerStrokeWidth]="strokeWidth"
  [outerStrokeColor]="dataColour"
  [innerStrokeColor]="baseColour"
  [innerStrokeWidth]="strokeWidth"
  [animation]="true"
  [animationDuration]="300"
  [space]="-1 * strokeWidth"
  [showTitle]="title !== ''"
  [showSubtitle]="subTitle !== ''"
  [showUnits]="false"
  [title]="title"
  [subtitle]="subTitle"></circle-progress>
